module.exports = __webpack_public_path__ + "media/images/affinity_logo-02d942c6a742e98ae66941492f6a2bcd.svg";